import { useParams, useNavigate } from "react-router-dom";
import { Dashboard } from "@/app/dashboard/Dashboard";
import { useAppContext } from "@/app/providers/AppContext";

const PortalPage = () => {
  const { tabId } = useParams();
  const activeTab = tabId || "overview";
  const navigate = useNavigate();

  const { profile, entitlements, api, loading } = useAppContext();

  const handleTabChange = (tabId: string) => {
    navigate(`/portal/${tabId}`);
  };

  const handleUpgrade = () => {
    handleTabChange("plans");
  };

  return (
    <Dashboard
      tabId={activeTab}
      profile={profile}
      entitlements={entitlements}
      loading={loading}
      onUpgrade={handleUpgrade}
      api={api}
      onNewWatch={() => navigate("/portal/watches/new")}
      onTabChange={handleTabChange}
    />
  );
};

export default PortalPage;
